import { AnimatePresence } from "@tamagui/animate-presence";
import { useMedia, YStack } from "@medbillai/ui";
import { CASES_PANEL_WIDTH, useCasesPanel } from "../../../provider/cases-panel";
import { IssueEventsProvider } from "../../../provider/issue-events";
import { CasesScreen } from "../../cases/screen";
export const CasesSlidePanel = () => {
  const {
    isOpen,
    togglePanel,
    isOnCasesPage,
    showRead,
    showUnread,
    showClosed,
    setFilters,
    markKeepOpen
  } = useCasesPanel();
  const media = useMedia();

  // Suppress on case pages (inline panel is used instead)
  if (isOnCasesPage) {
    return null;
  }

  // Only show on desktop screens
  if (!media.gtSm) {
    return null;
  }
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="CasesSlidePanel" data-sentry-source-file="CasesSlidePanel.web.tsx">
      {isOpen ? <>
          <YStack position="absolute" top={0} left={0} right={0} bottom={0} onPress={() => togglePanel("overlay_dismiss", false)} zIndex="$5" animation="200ms" enterStyle={{
        opacity: 0
      }} exitStyle={{
        opacity: 0
      }} cursor="pointer" />
          <YStack position="absolute" top={0} left={0} bottom={0} width={CASES_PANEL_WIDTH} borderRightWidth={1} borderRightColor="$strokeSecondary" backgroundColor="$background" zIndex="$modal" animation="200ms" enterStyle={{
        opacity: 0,
        x: -CASES_PANEL_WIDTH
      }} exitStyle={{
        opacity: 0,
        x: -CASES_PANEL_WIDTH
      }} overflow="hidden" shadow="light">
            <IssueEventsProvider>
              <CasesScreen filterState={{
            showRead,
            showUnread,
            showClosed,
            setFilters
          }} markKeepOpen={markKeepOpen} source="cases_slide_panel" />
            </IssueEventsProvider>
          </YStack>
        </> : null}
    </AnimatePresence>;
};